import React from "react";
import PropTypes from "prop-types";
import MenuBox from "./MenuBox";
import DataCanvasContainer from "./DataCanvasContainer";
import MemberButtonBox from "./MemberButtonBox";
import error from "./imagenotthere.png";

/*  App behavior is directly handled in main. Main stores the
 *  processed app state.
 */
export default class Main extends React.Component {
  constructor(props) {
      super(props);
      this.state = this.props.initialState;
  }

  // returns the string path to the image product that has been selected
  getSource = (n) => {
    return("../newse_images/"
    //return("https://wof.nssl.noaa.gov/newse_images/"
    + this.state.selectedDate + "/"
    + this.state.selectedCycle + "/"
    + this.state.selectedField + "_f"
    + (n || this.state.selectedUnit) + ".png");
  }

  handleDomainOftheDay = (bool) => {
    if(bool) {
      let product = `NEWSe_domain_${this.state.selectedDate}`
      const newQueryString = `?d=${this.state.selectedDate}&f=NEWSe_domain`;
      window.history.pushState(null, null, newQueryString);
      const domainImg = <img src={`../newse_images/${this.state.selectedDate}/${product}.png`}
      alt="Domain of the Day" onError={(e) => { e.target.src = error; }} />;
      let prevUnitType = this.state.selectedFieldUnitType;
      this.setState({ selectedFieldUnitType: "full", prevUnitType, domainImg });
    } else {
      const newQueryString = `?d=${this.state.selectedDate}&c=${this.state.selectedCycle}&f=${this.state.selectedField}`;
      const domainImg = <img src={this.getSource()}
      alt="Forecast" onError={(e) => { e.target.src = error; }} />
      window.history.pushState(null, null, newQueryString);
      this.setState({ domainImg, selectedFieldUnitType : this.state.prevUnitType });
    }
  }

  /* update the state and the query string in the url without refreshing the app */
  handleDateChange = (newDate) => {
    this.setState({ selectedDate: newDate, domainImg: null });
    const newQueryString = `?d=${newDate}&c=${this.state.selectedCycle}&f=${this.state.selectedField}`;
    window.history.pushState(null, null, newQueryString);
  }

  handleCycleChange = (newCycle) => {
    this.setState({ selectedCycle: newCycle, domainImg: null });
    const newQueryString = `?d=${this.state.selectedDate}&c=${newCycle}&f=${this.state.selectedField}`;
    window.history.pushState(null, null, newQueryString);
  }

  handleFieldChange = (newField, unit) => {

    this.setState({
      selectedField: newField,
      selectedFieldUnitType : unit,
      selectedUnit: unit ? this.props.data.units[unit].start : "000",
      domainImg: null
    });
    const newQueryString = `?d=${this.state.selectedDate}&c=${this.state.selectedCycle}&f=${newField}`
    window.history.pushState(null, null, newQueryString);
  }

  // the unit is the f number following the field/product name
  handleUnitChange = (newUnit) => {
    this.setState({ selectedUnit: newUnit, domainImg : null });
  }

  render() {
    return (
      <div className="main">
        <MenuBox
          data={this.props.data}
          dates={this.props.dates}
          selectedDate={this.state.selectedDate}
          handleDateChange={this.handleDateChange}
          handleCycleChange={this.handleCycleChange}
          handleFieldChange={this.handleFieldChange}
          handleDomainOftheDay={this.handleDomainOftheDay}/>

        <DataCanvasContainer
            getSource={this.getSource}
            onEvent={this.handleUnitChange}
            units={this.props.data["units"]}
            unit={!!this.state.selectedFieldUnitType ? this.state.selectedFieldUnitType : "minutes" }
            unitThreashold={this.props.data["cycles"][this.state.selectedCycle][!!this.state.selectedFieldUnitType ? this.state.selectedFieldUnitType : "minutes"]}
            product={this.state.selectedField}
            cycle={this.state.selectedCycle}
            date={this.state.selectedDate}
            domainImg={this.state.domainImg}
        />


        <div className="menu-box">
          <MemberButtonBox
            classname="members"
            onEvent={this.handleFieldChange}/>
        </div>
      </div>
    );
  }
}

Main.propTypes = {
  // data is from a json file structured specifically to populate
  // wof-essential menus. cycles, units, and fields are all included in the json
  data: PropTypes.object.isRequired,
  // an array of date strings is taken from a directory list
  dates: PropTypes.arrayOf(PropTypes.string).isRequired,
  // if the app is navigated to using query strings, the intial state
  // will refelct those choices (if they are formatted correctly)
  initialState: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/Main.js